<template>
  <div class="d-flex">
    <div class="position-absolute ml-2 mt-n10px h-15px font-12 bg-white z-999 px-1">Filtro de Fornecedores</div>

    <v-autocomplete
      :items="listaDeFornecedores"
      item-text="descricao_fornecedor"
      item-value="id_fornecedor"
      multiple
      outlined
      hide-details
      :placeholder="primeiroFornecedorSelecionado ? '' : 'Nenhum selecionado'"
    >
      <template v-slot:prepend-item>
        <v-list-item class="sys-item-prepended-list px-3 py-2" @click="selecionarTodos()">
          <template v-if="todosSelecionados">
            <v-icon color="primary">mdi-checkbox-marked</v-icon>
            <span class="subtitle-1 ml-3">Desmarcar todos os fornecedores</span>
          </template>
          <template v-else>
            <v-icon v-if="!fornecedoresSelecionados.length">mdi-checkbox-blank-outline</v-icon>
            <v-icon v-else color="primary">mdi-minus-box</v-icon>
            <span class="subtitle-1 ml-3">Selecionar todos os fornecedores</span>
          </template>
        </v-list-item>

        <v-divider />
      </template>

      <template v-slot:item="{item}">
        <v-list-item class="item-list px-3" @click="addOuRemoveItem(item)">
          <v-list-item-icon>
            <v-icon v-if="fornecedorSelecionado(item)" color="primary">
              mdi-checkbox-marked
            </v-icon>
            <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="ml-n6">
            <v-list-item-title>{{ item.id_fornecedor }} - {{ item.descricao_fornecedor }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>

      <template v-slot:prepend-inner v-if="fornecedoresSelecionados.length > 0">
        <v-chip dense class="ma-0 mt-n1">{{ primeiroFornecedorSelecionado }}</v-chip>
      </template>

      <template v-slot:append>
        <template v-if="fornecedoresSelecionados.length > 1">
          <v-chip small outlined color="#666666" style="height: 20px">
            {{ `${fornecedoresSelecionados.length} selecionados`}}
          </v-chip>
        </template>
        <template v-else>
          <v-icon>mdi-filter</v-icon>
        </template>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import mixin from '../MixinDRP'

export default {
  name: "filtroDeFornecedor",
  model: {
    prop: 'fornecedoresSelecionados',
    event: 'change-fornecedores'
  },
  props: {
    fornecedoresSelecionados: {
      type: Array,
      required: true
    },
    itensFull: {
      type: Array,
      required: false
    }
  },
  mixins: [mixin],
  computed: {
    listaDeFornecedores () {
      return this.itensFull;
    },
    todosSelecionados () {
      return this.fornecedoresSelecionados.length > 0 && this.fornecedoresSelecionados.length === this.listaDeFornecedores.length
    },
    primeiroFornecedorSelecionado () {
      if (this.fornecedoresSelecionados.length === 0) return 0;

      return this.fornecedoresSelecionados[0].descricao_fornecedor.trim();
    }
  },
  methods: {
    fornecedorSelecionado (item) {
      const selecionado = this.fornecedoresSelecionados.filter(forn => forn.id_fornecedor == item.id_fornecedor)

      return selecionado.length > 0
    },
    selecionarFornecedores (ev) {
      this.$emit('change-fornecedores', ev)
    },
    selecionarTodos () {
      if (this.todosSelecionados) {
        this.selecionarFornecedores([])
      } else {
        this.selecionarFornecedores(this.listaDeFornecedores)
      }
    },
    addOuRemoveItem (item) {
      let novosSelecionados

      if (this.fornecedorSelecionado(item)) {
        novosSelecionados = this.fornecedoresSelecionados.filter(fornecedor => fornecedor.id_fornecedor != item.id_fornecedor)
      } else {
        novosSelecionados = this.fornecedoresSelecionados.concat(item)
      }

      this.selecionarFornecedores(novosSelecionados)
    }
  }
}
</script>

<style scoped>
.txt-primeiro-selecionado {
  font-size: 13px;
  white-space: nowrap;
  width: 13em;
}
</style>
